import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';

export const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-100">
      <nav className="bg-white shadow-sm">
        <div className="container-app">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-8">
              <Link to="/" className="text-xl font-bold text-gray-800">
                VicaTalk
              </Link>
              <div className="hidden md:flex space-x-4">
                <Link to="/admin/dashboard" className="text-gray-700 hover:text-gray-900">
                  Dashboard
                </Link>
                <Link to="/admin/users" className="text-gray-700 hover:text-gray-900">
                  Users
                </Link>
                <Link to="/editor/articles" className="text-gray-700 hover:text-gray-900">
                  Articles
                </Link>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-gray-700">{user?.name}</span>
              <span className="px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">
                {user?.role}
              </span>
              <Button size="sm" variant="outline" onClick={logout}>
                Logout
              </Button>
            </div>
          </div>
        </div>
      </nav>
      <main className="container-app py-8">{children}</main>
    </div>
  );
};
